// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {ajax} from './config/jQueryAjax'
import { download, postDownload } from './config/http'
import store from './store/'
import { JSEncrypt } from 'jsencrypt'
import { Base64 } from 'js-base64'
import VCharts from 'v-charts'
import promise from 'es6-promise'
import CommonSearch from '@/components/common_search.vue'
// import { sha256 } from 'js-sha256'
import filters from './js/filter.js';

// 批量注册过滤器：遍历 filters 对象，逐个注册为全局过滤器
Object.keys(filters).forEach(filterName => {
  Vue.filter(filterName, filters[filterName]);
});

Vue.component("CommonSearch", CommonSearch);//全局自定义组件

promise.polyfill();
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$ajax = ajax
//定义全局变量 下载
Vue.prototype.$download = download;
Vue.prototype.$postDownload = postDownload;

Vue.use(VCharts)
//JSEncrypt加密方法
Vue.prototype.$encryptedData = function(publicKey, data) {
  //new一个对象
  let encrypt = new JSEncrypt()
  //设置公钥
  encrypt.setPublicKey(publicKey)
  //password是要加密的数据,此处不用注意+号,因为rsa自己本身已经base64转码了,不存在+,全部是二进制数据
  let result = encrypt.encrypt(data)
  return result
}
//JSEncrypt解密方法
Vue.prototype.$decryptData = function(privateKey, data) {
  // 新建JSEncrypt对象
  let decrypt = new JSEncrypt()
  // 设置私钥
  decrypt.setPrivateKey(privateKey)
  // 解密数据
  let result = decrypt.decrypt(data)
  return result
}
// Vue.prototype.$sha256 = sha256
/**
 * 长文本加密
 * @param {string} string 待加密长文本
 * @returns {string} 加密后的base64编码
* */
Vue.prototype.$encryptLong = function (publicKey,string) {
    // var k = this.getKey();
    // 新建JSEncrypt对象
    let k = new JSEncrypt()
    // 设置私钥
    k.setPublicKey(publicKey)
    try {
        var ct = "";
        //RSA每次加密117bytes，需要辅助方法判断字符串截取位置
        //1.获取字符串截取点
        var bytes = new Array();
        bytes.push(0);
        var byteNo = 0;
        var len, c;
        len = string.length;
        var temp = 0;
        for (var i = 0; i < len; i++) {
            c = string.charCodeAt(i);
            if (c >= 0x010000 && c <= 0x10FFFF) {  //特殊字符，如Ř，Ţ
                byteNo += 4;
            } else if (c >= 0x000800 && c <= 0x00FFFF) { //中文以及标点符号
                byteNo += 3;
            } else if (c >= 0x000080 && c <= 0x0007FF) { //特殊字符，如È，Ò
                byteNo += 2;
            } else { // 英文以及标点符号
                byteNo += 1;
            }
            if ((byteNo % 117) >= 114 || (byteNo % 117) == 0) {
                if (byteNo - temp >= 114) {
                    bytes.push(i);
                    temp = byteNo;
                }
            }
        }
        //2.截取字符串并分段加密
        if (bytes.length > 1) {
            for (var i = 0; i < bytes.length - 1; i++) {
                var str;
                if (i == 0) {
                    str = string.substring(0, bytes[i + 1] + 1);
                } else {
                    str = string.substring(bytes[i] + 1, bytes[i + 1] + 1);
                }
                var t1 = k.encrypt(str);
                ct += t1;
            }
            ;
            if (bytes[bytes.length - 1] != string.length - 1) {
                var lastStr = string.substring(bytes[bytes.length - 1] + 1);
                ct += k.encrypt(lastStr);
            }
            return Base64.encode(ct);
        }
        var t = k.encrypt(string);
        var y = Base64.encode(t);
        return y;
    } catch (ex) {
        console.log(ex);
        return false;
    }
};

/**
 * 长文本解密
 * @param {string} string 加密后的base64编码
 * @returns {string} 解密后的原文
 * */
Vue.prototype.decryptLong = function (privateKey,string) {
    // var k = this.getKey();
    let k = new JSEncrypt()
    // 设置私钥
    k.setPrivateKey(privateKey)
    var maxLength = 128;
    try {
        var string = b64tohex(string);
        var ct = "";
        if (string.length > maxLength * 2) {
            var lt = string.match(/.{1,256}/g);  //128位解密。取256位
            lt.forEach(function (entry) {
                var t1 = k.decrypt(entry);
                ct += t1;
            });
            return ct;
        }
        var y = k.decrypt(string);
        return y;
    } catch (ex) {
        return false;
    }
};

//挂载全局方法
//登录拦截 beforeEach是router的钩子函数，该函数在进入每个网页之前调用
// 1：from: 即将离开的路由
// 2：to: 即将要跳转的路由
// 3：next: 跳转方法。
router.beforeEach((to, from, next) => {

  let userbh = window.sessionStorage.getItem('userbh');
  let username = window.sessionStorage.getItem('username');
  let token = window.sessionStorage.getItem('token');
  let roleId = window.sessionStorage.getItem('roleId');
  let utype = window.sessionStorage.getItem('utype');

  if(token == null || token === 'null'){//没有登录
    // 允许访问的公共页面（404页面、隐私页面等）
    if(to.path =='/notice_view' || to.path == '/privacy' || to.path == '/login_notice' || to.path == '/404' || to.meta.noAuth){
      next()
    }else if(to.path == '/'){
      // 访问根路径时，让路由配置中的redirect处理，不拦截
      next()
    }else{
      // 访问其他页面时，跳转到对应登录页
      if(to.path != "/login"){
        if (to.path != "/merch/login") {
          next({
            path:
              process.env.VUE_APP_BUILD_ADMIN == "cheil-pdd1" || process.env.VUE_APP_BUILD_ADMIN == "cheil-stg"
                ? "/login"
                : process.env.VUE_APP_BUILD_ADMIN == "cheil-2025" || process.env.VUE_APP_BUILD_ADMIN == "cheil-stg-merchant"
                ? "/merch/login"
                : "/",
          });
        } else {
          next();
        }
      }else{
        next();
      }
    }
  }else{
    // 已登录
    let userInfo={'userbh':userbh,'username':username,'token':token};
    store.dispatch('saveUserInfo', userInfo);
    
    // 已登录访问登录页，跳转到对应首页
    if(to.path === "/login"){
      if (utype === "pt") {
        // 管理员已登录访问管理员登录页，跳转到管理员首页
        next({path: '/sys_order/order'});
      } else if (utype === "mer") {
        // 商户已登录访问管理员登录页，跳转到商户首页
        next({path: '/mer_home/site'});
      } else {
        next();
      }
    } else if (to.path === "/merch/login") {
      if (utype === "mer") {
        // 商户已登录访问商户登录页，跳转到商户首页
        next({path: '/mer_home/site'});
      } else if (utype === "pt") {
        // 管理员已登录访问商户登录页，跳转到管理员首页
        next({path: '/sys_order/order'});
      } else {
        next();
      }
    } else {
      // 权限检查：管理员不能访问商户页面
      if (utype === 'pt' && (to.path.startsWith('/mer_home') || to.path.startsWith('/mer_apply') || to.path.startsWith('/mer_order') || to.path.startsWith('/mer_data'))) {
        // 管理员访问商户页面，跳转到404
        next({path: '/404'});
        return;
      }

      // 权限检查：商户不能访问管理员页面
      if (utype === 'mer' && (to.path.startsWith('/sys_'))) {
        // 商户访问管理员页面，跳转到404
        next({path: '/404'});
        return;
      }

      // 管理员动态路由未加载，需要先加载动态路由
      if (utype == 'pt' && store.state.dynamicRouter == false) {
        // 继续执行下面的动态路由加载逻辑，不要调用 next()
      } else {
        // 已加载动态路由或非管理员，正常放行
        next();
      }
    }
  }

  // 判断路由状态，加载管理员动态路由
  if(store.state.dynamicRouter == false && utype == 'pt') {
    let index = 0;
    let home_path;
    ajax({
      url:"coupon-system/menu/getAuthByRole",
      methods:'GET',
      async:false,
      data:{'roleId':roleId,'token':token},
      success:function(response){
        if (response.code == 0 && response.data != null) {
          let permissionsData = response.data;
          //创建一个数组用来存储符合权限的路由
          let dataRouter = [];
          //循环遍历动态路由表的每一个路由
          for (let i=0;i<permissionsData.length;i++){
             let data = {};
             data['path'] = permissionsData[i].path;
             data['name'] = permissionsData[i].name;
             data['meta'] = permissionsData[i].meta;
             data['component'] = getViews(permissionsData[i].component);
             //获取子集合
             let childrens = permissionsData[i].children;
             if (childrens == null) {
               childrens = [];
             }
             let dataChildRouter = [];
             for(let j=0;j<childrens.length;j++){
               if(j == 0){
                 data['redirect'] = childrens[j].path;
               }
               if(index == 0){
                 home_path = childrens[j].path;
                 index = 1;
               }
               let cdata = {};
               cdata['path'] = childrens[j].path;
               cdata['name'] = childrens[j].name;
               cdata['meta'] = childrens[j].meta;
               cdata['menutype'] = childrens[j].menutype;
               cdata['component'] = getViews(childrens[j].component);

               let childrens2 = childrens[j].children;
               if(childrens2 != null){
                 let dataChildRouter2 = [];
                 for(let k=0;k<childrens2.length;k++){
                  if(j == 0 && k == 0){
                    cdata['redirect'] = childrens2[k].path;
                  }
                   let cdata2 = {};
                   cdata2['path'] = childrens2[k].path;
                   cdata2['name'] = childrens2[k].name;
                   cdata2['meta'] = childrens2[k].meta;
                   cdata2['menutype'] = childrens2[k].menutype;
                   cdata2['component'] = getViews(childrens2[k].component);
                   dataChildRouter2.push(cdata2);
                 }
                 cdata['children'] = dataChildRouter2;
               }


               dataChildRouter.push(cdata);
             }
             data['children'] = dataChildRouter;
             dataRouter.push(data);
          }
          // 将路由信息存到sessionStorage里
          window.sessionStorage.setItem("home_path", home_path);
          //保存路由状态
          store.dispatch('saveDynamicRouter', true);
          router.options.routes = dataRouter;

          // 使用 router.addRoute 替代已弃用的 router.addRoutes
          dataRouter.forEach(route => {
            router.addRoute(route);
          });

          // 添加404通配符路由到最后，确保动态路由能被匹配
          router.addRoute({
            path: '*',
            redirect: '/404'
          });

          next({...to,replace: true });//解决刷新后页面为空的问题
        } else {
          // token无效或数据为null，提示重新登录
          Vue.prototype.$message.error(response.message || '请重新登录');
          window.sessionStorage.clear();
          next('/login');
        }
      },
      error:function(){
        Vue.prototype.$message.error('请重新登录');
        window.sessionStorage.clear();
        next('/login');
      }
    });
  }



  // if (to.meta.requireAuth) { // 判断跳转的路由是否需要登录
  //     if (store.state.userInfo.token || token) { // vuex.state判断token是否存在
  //       let userInfo={'userbh':userbh,'username':username,'token':token};
  //       store.dispatch('saveUserInfo', userInfo);
  //       next() // 已登录
  //     } else {
  //       next({
  //         path: '/login',
  //         query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
  //       })
  //     }
  // } else {
  //    next()
  // }
});

//登录拦截 afterEach是router的钩子函数，该函数在每个网页之后调用
router.afterEach(function (to) {
})

function getViews(path) {
  // return import('@/components/' + path);
  return resolve => {
    require.ensure([], (require) => {
      resolve(require('@/components/' + path))
    })
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js